import React from 'react'
import Dashboard from '../Components/Admin/Dashboard'

function AdminDashboard() {
    return (
        <div>
            <Dashboard />
        </div>
    )
}

export default AdminDashboard
